<template>
<div>
    <div class="app-title">
        <div>
            <h2>{{$t('tlt.shiftHandOver')}}</h2>
            <ul class="app-breadcrumb breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/"><i class="fa fa-home"></i></router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/prd"><span>{{$t('tlt.prd')}}</span></router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/prd/shiftHandOver"><span>{{$t('tlt.shiftHandOver')}}</span></router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/prd/shiftHandOver/edit"><span>{{$t('tlt.shiftHandOver.new')}}</span></router-link>
                </li>
            </ul>
        </div>
        <div class="col-lg-4">
            <div class="float-lg-right">
                <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('shiftHandOver')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>{{$t('btn.shiftHandOver.cancle')}}</span></button>
                <button class="btn btn-primary" style="margin:10px" type="button" v-on:click="save()"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.shiftHandOver.temStorage')}}</span></button>
                <button class="btn btn-primary" type="button" v-on:click="commit()"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.shiftHandOver.submit')}}</span></button>
            </div>
        </div>
    </div>

    <section class="app-content">
        <form>
            <div class="card">
                <div class="card-body">
                    <div class="row">                        
                        <div class="form-group col-md-2">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftHandOver.day')}}:</label>
                            <mmf-datepicker v-validate="'required'" name="day" v-model="day" :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('day') }"></mmf-datepicker >
                            <span v-show="errors.has('day')" class="lbl-obg">
                                {{ errors.first('day') }}
                            </span>
                        </div>                       
                        <div class="form-group col-md-2" style="display: none">
                            <label class="control-label"><span
                                    class="lbl-obg">*</span>{{$t('lbl.shiftHandOver.locId')}}:</label>
                            <dimSearch  validate="required" name="locId"
                                        v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="shiftHandoverLocation">
                            </dimSearch>
                        </div>

                        <div class="form-group col-md-2">
                            <label class="control-label"><span
                                    class="lbl-obg">*</span>{{$t('lbl.shiftHandOver.locName')}}:</label>
                            <dimSearch  validate="required" name="locName"
                                        v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="shiftHandoverLocation">
                            </dimSearch>
                        </div>
                        <div class="form-group col-md-2">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftHandOver.shift')}}:</label>
                            <select :class="{'form-control': true, 'is-invalid': errors.has('shift') }" v-model="shift" v-validate="'required'" name="shift">
                                <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                <option value="1">{{ $t("甲") }}</option>
                                <option value="2">{{ $t("乙") }}</option>
                                <option value="3">{{ $t("丙") }}</option>
                            </select>
                            <span v-show="errors.has('shift')" class="lbl-obg">
                                {{ errors.first('shift') }}
                            </span>
                        </div>
                        
                        <div class="form-group col-md-2">
                            <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.shiftHandOver.weather')}}:</label>
                            <input name="weather" :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('weather') }" v-model="weather" type="text">
                            <span v-show="errors.has('weather')" class="lbl-obg">
                                {{ errors.first('weather') }}
                            </span>
                        </div>
                        <div class="form-group col-md-2">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftHandOver.handoverManager')}}:</label>
                            <!-- <input v-validate="'required'" name="handoverManager" :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('handoverManager') }" v-model="handoverManager" type="text"> -->
                            <!-- <span v-show="errors.has('handoverManager')" class="lbl-obg">
                                {{ errors.first('handoverManager') }}
                            </span> -->
                            <dimSearch  validate="required" name="handoverManager"
                                        v-model="handoverManager" :entity="users" submitProp="name" bindProp="name" bindId="handoverManager">
                            </dimSearch> 
                        </div>
                        <div class="form-group col-md-2">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftHandOver.handoverDutyMan')}}:</label>
                            <input v-validate="'required'" name="handoverDutyMan" :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('handoverDutyMan') }" v-model="handoverDutyMan" type="text">
                            <span v-show="errors.has('handoverDutyMan')" class="lbl-obg">
                                {{ errors.first('handoverDutyMan') }}
                            </span>
                        </div>
                        <div class="form-group col-md-2">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftHandOver.dailyManager')}}:</label>
                            <!-- <input v-validate="'required'" name="dailyManager" :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('dailyManager') }" v-model="dailyManager" type="text">
                            <span v-show="errors.has('dailyManager')" class="lbl-obg">
                                {{ errors.first('dailyManager') }}
                            </span> -->
                            <dimSearch  validate="required" name="dailyManager"
                                        v-model="dailyManager" :entity="users" submitProp="name" bindProp="name" bindId="dailyManager">
                            </dimSearch> 
                        </div>
                        <div class="form-group col-md-2">
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftHandOver.dailyDutyMan')}}:</label>
                            <input v-validate="'required'" name="dailyDutyMan" :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('dailyDutyMan') }" v-model="dailyDutyMan" type="text">
                            <span v-show="errors.has('dailyDutyMan')" class="lbl-obg">
                                {{ errors.first('dailyDutyMan') }}
                            </span>
                        </div>
                    </div>
                    <hr>
<!--                    运行记录组件-->
                    <div class="row">
                        <div class="form-group col-md-12" v-show='showValueEditor'>
                            <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftHandOver.runLog')}}:</label>
                            <div>
                                <dynamic-form ></dynamic-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</div>
</template>



<script>
import {
    createHelpers
} from 'vuex-map-fields';
import {
    mapActions,mapState
} from "vuex";
import {
    fields
} from "@/model/prd/shiftHandOver/ShiftHandOver";


import dynamicForm from "@/views/prd/shiftHandOver/DynamicForm.vue"
import MmfDatepicker from "@/components/MmfDatepicker";
import MmfDatetimepicker from "@/components/MmfDatetimepicker";
import dimSearch from "@/components/MMFDimSearch";

const {
    mapFields
} = createHelpers({
    getterType: 'shiftHandOver/getField',
    mutationType: 'shiftHandOver/updateField',
});
export default {
    data() {
        return {
            cmOptions: {
                tabSize: 4,
                mode: 'text/plain',
                theme: 'eclipse',
                lineNumbers: true,
                line: true,
            }
        }
    },
    beforeMount() {
            this.$store.dispatch('shiftHandOver/loadLocations'); 
            this.$store.dispatch('shiftHandOver/loadUsers');           
    },
    mounted() {
        this.changeEditor();
        // this.MMFCheckState('shiftHandOver');
    },
    computed: {
        ...mapState({
            entity: state => state.shiftHandOver.entity,
            locations: state => state.shiftHandOver.locations,
            users: state => state.shiftHandOver.users,
        }),
        ...mapFields(fields),
        showValueEditor() {
            return this.$store.state.shiftHandOver.showValueEditor
        },
        showValueInput() {
            return this.$store.state.shiftHandOver.showValueInput
        },
        showValueBoolean() {
            return this.$store.state.shiftHandOver.showValueBoolean
        }
    },
    methods: {
        save(){
            this.entity.editAble = 1;
            this.entity.status = 0;
            this.MMFSave('shiftHandOver');
        },
        commit(){
            this.entity.editAble = -1;
            this.entity.status = 1;
            this.MMFSave('shiftHandOver');
        }

        ,
        ...mapActions("base", ["MMFbackToList", "MMFSave"]),
        changeEditor() {
            var dtType = this.$store.state.shiftHandOver.entity.dataType;
            var me = this;

            var toogleEditor = function () {
                me.$store.commit('shiftHandOver/toggleShowValueEditor', true);
                me.$store.commit('shiftHandOver/toggleShowValueInput', false);
                me.$store.commit('shiftHandOver/toggleShowValueBoolean', false);
            }
            var toogleInput = function () {
                me.$store.commit('shiftHandOver/toggleShowValueEditor', false);
                me.$store.commit('shiftHandOver/toggleShowValueInput', true);
                me.$store.commit('shiftHandOver/toggleShowValueBoolean', false);
            }
            var toogleBoolean = function () {
                me.$store.commit('shiftHandOver/toggleShowValueEditor', false);
                me.$store.commit('shiftHandOver/toggleShowValueInput', false);
                me.$store.commit('shiftHandOver/toggleShowValueBoolean', true);
            }

            switch (dtType) {
                case 'X':
                    toogleEditor();
                    //this.$refs.myCm.codemirror.setOption("mode", 'text/xml');
                    break;
                case 'J':
                    toogleEditor();
                    //this.$refs.myCm.codemirror.setOption("mode", 'text/javascript');
                    break;
                case 'Y':
                    toogleEditor();
                    //this.$refs.myCm.codemirror.setOption("mode", 'text/yaml');
                    break;
                case 'P':
                    toogleEditor();
                    //this.$refs.myCm.codemirror.setOption("mode", 'text/x-properties');
                    break;
                default:
                    toogleEditor();
                    //this.$refs.myCm.codemirror.setOption("mode", 'text/plain');
                    break;
                case 'N':
                case 'D':
                case 'U':
                    toogleInput();
                    console.log("input")
                    break;
                case 'B':
                    console.log("boolean")
                    toogleBoolean();
                    console.log("boolean")
                    break;
            }
        },
        validateForm() {
            this.$store.dispatch('base/MMFSave', 'shiftHandOver');
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    this.$store.dispatch('base/MMFSave', 'shiftHandOver');
                }
            });
        }
    },
    components: {
        // codemirror,
        dynamicForm,
        MmfDatepicker,
        // MmfDatetimepicker,
        dimSearch
    }
};
</script>
